import { render } from "./SwitchRow.vue?vue&type=template&id=9be9a8c8&scoped=true"
import script from "./SwitchRow.vue?vue&type=script&lang=js"
export * from "./SwitchRow.vue?vue&type=script&lang=js"

import "./SwitchRow.vue?vue&type=style&index=0&id=9be9a8c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9be9a8c8"

export default script